<template>
  <template v-if="blockedAt && blockReason === payinBlockReason.precautionaryBlocking">
    <card-info
      v-if="status === payinStatus.received && unblockedAt"
      color="green"
      icon="check"
    >
      <bg-text type="body-md">
        Foi <b>disponibilizado</b> em sua conta o valor de <formatted-amount />, bloqueado
        temporariamente em <formatted-date :date="blockedAt" />, referente à transação Pix feita por
        <fomattedPayerName />, em
        <formatted-date :date="receivedAt" />.
      </bg-text>
    </card-info>
    <card-info
      v-else-if="status === payinStatus.refunded"
      color="blue"
      icon="back-arrow"
    >
      <bg-text type="body-md">
        Foi efetuada a <b>devolução</b> para em sua conta o valor de <formatted-amount />, bloqueado
        temporariamente em <formatted-date :date="blockedAt" />, referente à transação
        Pix feita por <fomatted-payer-name />, em <formatted-date :date="receivedAt" />.
      </bg-text>
    </card-info>
    <card-info
      v-else-if="status === payinStatus.blocked"
      color="grey"
      icon="shield"
    >
      <bg-text type="body-md">
        Foi efetuado em sua conta o <b>bloqueio cautelar</b> no valor de <formatted-amount />,
        referente
        à transação Pix feita por <fomatted-payer-name />, em <formatted-date :date="receivedAt" />.
        O valor poderá ficar bloqueado temporariamente por até 72 horas. Você pode aguardar a
        liberação ou optar por devolver o valor ao pagador.
      </bg-text>
      <bg-text type="body-md">
        Mais informações serão enviadas por e-mail.
      </bg-text>
    </card-info>
  </template>
</template>

<script lang="jsx" setup>
import CardInfo from '@/commons/components/presentational/CardInfo.vue';
import { centsToReal } from '@/commons/formatters/currency';
import { formatDateTime } from '@/commons/formatters/formatDate';
import { payinBlockReason, payinStatus } from '@transfeeradev/api-enums/payinApi';
import { BgText } from '@transfeeradev/bridge';
import { useCssModule } from 'vue';

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  blockReason: {
    type: String,
    required: true
  },
  blockedAt: {
    type: String,
    required: true
  },
  blockedAmountCents: {
    type: Number,
    required: true
  },
  unblockedAt: {
    type: String,
    required: false
  },
  payerName: {
    type: String,
    required: true
  },
  receivedAt: {
    type: String,
    required: true
  }
});

const style = useCssModule();

const fomattedPayerName = () => <b>{props.payerName}</b>;
const formattedDate = ({ date }) => <b>{formatDateTime(date, 'DD/MM/YYYY, [às] HH:mm')}</b>;
const formattedAmount = () => <b class={style.nowrap}>{centsToReal(props.blockedAmountCents)}</b>;
</script>

<style module scoped>
.nowrap {
  white-space: nowrap;
}
</style>
